<template>
  <div>
    <TeCourseFirstSidejobCover :closes-at="closesAt" />

    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faHouseLaptop"
          class="fa-fw mr-2"
        />
      </template>
      <template #coursename>
        はじめての副業<span class="hidden md:inline">コース</span>
      </template>
      <template #menu>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#merit'"
            @click.prevent="scrollTo('merit')"
          >
            特長
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#curriculum'"
            @click.prevent="scrollTo('curriculum')"
          >
            カリキュラム
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#price'"
            @click.prevent="scrollTo('price')"
          >
            料金
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#flow'"
            @click.prevent="scrollTo('flow')"
          >
            受講の流れ
          </a>
        </li>
        <!-- 251202導線削除 -->
        <!-- <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#faq'"
            @click.prevent="scrollTo('faq')"
          >
            FAQ
          </a>
        </li> -->
      </template>
    </TeCommonPagenav>

    <!-- 251202導線削除 -->
    <!-- <TeCourseFirstSidejobBannerLinks /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerThousand />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />

    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />

    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <!-- はじめての副業コースの特長 -->
    <TeCourseFirstSidejobMerit />

    <!--テックアカデミーだけの副業サポート -->
    <TeCommonTechAcademyWorks :work-example="true" />

    <!-- 副業の圧倒的な実績 -->
    <section
      id="sidejob-achievement"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-5 py-20">
        <!-- セクションタイトル -->
        <div class="text-center">
          <h2 class="co-heading-2">
            副業の圧倒的な実績
          </h2>
          <h3 class="mb-2 text-[1.25rem] font-bold md:text-[1.75rem]">
            副業を成功させた卒業生
          </h3>
          <span class="mb-7 inline-block text-left text-[0.625rem] text-co-gray-500 md:text-center md:text-[0.75rem]">
            ※個人差があります。すべての方に同様の結果を保証するものではありません。
          </span>
        </div>

        <!-- 卒業生 -->
        <!-- 横幅1100px -->
        <TeCommonGraduateFirstSidejobNew />
      </div>
    </section>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-first"
      :sidejob="true"
    /> -->

    <TeCourseFirstSidejobCurriculumNew />

    <TeCommonBannerAdobe />

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          副業をはじめる
        </template>
        <template #originalTitle>
          テックアカデミーワークスで副業
        </template>
        <template #learningLead>
          パーソナルメンターとの定期的なメンタリング、チャットサポート、課題レビュー、宿題に取り組みながらオリジナルWebサイトを制作できるスキルを身につけます。
        </template>
        <template #ThirdContentsTitle>
          <FontAwesomeIcon
            :icon="faCheck"
            class="co-display-7 mr-3 w-7 text-co-danger-500"
          />
          最終課題合格後に審査を受ける
        </template>
        <template #ThirdContentsLead>
          最終課題合格後にデザインカンプをもとにWebページを制作して提出いただきます。提出されたものを審査して、通過した場合は「テックアカデミーワークス」を使って副業することができます。
        </template>
        <template #originalLead>
          最初は案件をメンターと一緒に取り組むので初心者でも安心して副業ができます。複数の案件をこなしたあとは、ご自身で案件を進めていただきます。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor>
        <template #mentor>
          Webデザイナー
        </template>
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-kano.webp"
            alt="Hirokazu Kano"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Hirokazu
          <br>
          Kano
        </template>
        <template #mentorProfile1>
          Web制作/開発の主要スキルを網羅、実務経験は15年以上。<br>現在は起業した会社でサイトの開発・運用を行う。取引先企業の数千万を超える売上増加に貢献。
        </template>
        <template #mentorMessage1>
          受講後に自分の力で案件ができるようわかりやすくサポートします！
        </template>
        <template #mentorImage2>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-yamamoto-white.webp"
            alt="Yoshihito Yamamoto"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName2>
          Yoshihito
          <br>
          Yamamoto
        </template>
        <template #mentorProfile2>
          Web制作/開発経験14年以上。<br>フリーでWeb制作/開発を月5件ほど請負い、その他も豊富なスキルで幅広い案件に対応。会社員時代は新人教育も担当。
        </template>
        <template #mentorMessage2>
          初心者でも挫折せず最後まで楽しんで受講できるようにサポートします！
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason>
        <template #mentorType>
          Webデザイナー
        </template>
      </TeCommonMentorSupportReason>
    </section>

    <TeCourseReviewsTwitter :mentoring="false" />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-second"
      :sidejob="true"
    /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-5 py-20 xl:px-0">
        <h2 class="co-heading-2">
          料金プラン
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeTeCourseFirstSidejobPriceTable3Columns
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
          :mentoring="true"
          :chat-support="true"
        >
          <template #additionalFees>
            Adobe Creative Cloud Pro 個人版のご利用に対し、3ヶ月分クーポンを発行いたします。3ヶ月以降、ご利用になる場合は別途料金（月額7,780円、2025年7月30日時点）が発生します。受講料には含まれませんのでご注意ください。
          </template>
        </TeTeCourseFirstSidejobPriceTable3Columns>

        <TeCoursePriceGreatPlan
          :course="course"
          :is4-weeks-plan="false"
          :is-student="false"
        />

        <TeCoursePriceInstallments
          :course="course"
          :installments-social8-week="true"
        />

        <!-- リスキルアンカーリンク -->
        <div class="mb-[3.25rem] flex flex-col items-center justify-center md:flex-row">
          <p class="mb-2 md:mb-0 md:mr-3">
            リスキリング補助制度の利用をご検討の方はこちらもご覧ください
          </p>
          <a
            class="te-reskilling-anker rounded px-6 py-3"
            href="#careerup"
            @click.prevent="scrollTo('careerup')"
          >
            詳細はこちら
            <FontAwesomeIcon
              :icon="faAngleRight"
              class="fa-fw inline h-4 w-5"
            />
          </a>
        </div>

        <!-- 早めの申し込み・入金がお得！バナー -->
        <TeCommonPricePreviously>
          <template #notes>
            <p class="co-display-13 mb-0 text-co-gray-400">
              ※先割の場合は通常よりも3週間早く受講を開始できます。
            </p>
          </template>
        </TeCommonPricePreviously>

        <!-- クラウドローンバナー -->
        <!-- Educareテスト開始、クラウドローンバナーはコメントアウト -->
        <!-- <TeCommonBannerCrowdloan /> -->

        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              PCスペック：Photoshopの最小技術仕様を満たしている<span class="inline md:block">（詳細な内容は<a
                href="https://helpx.adobe.com/jp/photoshop/system-requirements.html"
                target="_blank"
              >こちら</a>）</span>
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </TeCommonPriceParticipationconditions>

        <div class="flex flex-col lg:flex-row">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions>
            <template #preCautionsList>
              <li class="mb-2">
                支払い方法はクレジットカード払い（分割可能）、コンビニ決済、銀行振込、Amazon Pay、PayPayからお選びいただけます。
              </li>
              <li class="mb-2">
                クレジットカード払いは、Visa、Master、JCB、AMEX、Dinersに対応しています。
              </li>
              <li class="mb-2">
                カード分割払いご利用回数（3/5/6/10/12/15/18/20/24）
              </li>
              <li class="mb-2">
                Dinersは分割の支払いが利用できません。
              </li>
              <li class="mb-2">
                コンビニ決済は30万円を超える支払いにはご利用いただけません。
              </li>
              <li class="mb-2">
                50万円を超えるPayPay決済をご利用の際は、本人確認の認証が必要となります。
              </li>
              <li class="mb-2">
                請求書払いをご希望の場合はお申込後、専用のフォームからご申請ください。
              </li>
              <li class="mb-2">
                決済後、専用のフォームから領収書の発行が可能です。
              </li>
              <li class="mb-2">
                学生は25歳以下が対象、学生証の提示が必要です。
              </li>
              <li class="mb-2">
                参加にはウェブカメラ、マイクが必要となります。
              </li>
              <li>12/28から1/3はメンターサポート休止期間です。受講期間がサポート休止期間にかかる場合、受講が最大7日間延長されます。</li>
            </template>
          </TeCommonPricePrecautions>

          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #annotation02>
        ※8週間プランは先割の対象外です。
      </template>
    </TeCourseSakiwari>

    <!-- トモ割 -->
    <TeCommonTomowari
      bg="#89a95e"
      title-bg="#6f8a4a"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :course="course"
      :course16weeks="true"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial
      id="cta-third"
      :sidejob="true"
    /> -->

    <TeCommonComparisonSchoolSidejob :benefits="true" />

    <TeCourseFirstSidejobFlow>
      <template #goal>
        オリエンテーションにて目標設定
      </template>
    </TeCourseFirstSidejobFlow>

    <!-- 251202導線削除 -->
    <!-- <TeCourseFirstSidejobFaQ /> -->

    <TeCommonBannerPcBeginner />

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseFirstSidejobCover from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCourseFirstSidejobBannerLinks from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobBannerLinks.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerThousand from '~/components/Te/TeCommon/Banner/TeCommonBannerThousand/TeCommonBannerThousand.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseFirstSidejobMerit from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobMerit.vue'
import TeCommonTechAcademyWorks from '~/components/Te/TeCommon/TeCommonTechAcademyWorks/TeCommonTechAcademyWorks.vue'
import TeCommonGraduateFirstSidejobNew from '~/components/Te/TeCommon/Graduate/TeCommonGraduateFirstSidejobNew/TeCommonGraduateFirstSidejobNew.vue'
import TeCommonSliderWorkExample from '~/components/Te/TeCommon/Slider/TeCommonSliderWorkExample.vue'
import TeCommonSidejobTimeSchedule from '~/components/Te/TeCommon/Sidejob/TeCommonSidejobTimeSchedule/TeCommonSidejobTimeSchedule.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCourseFirstSidejobCurriculumNew from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobCurriculumNew.vue'
import TeCommonBannerAdobe from '~/components/Te/TeCommon/Banner/TeCommonBannerAdobe/TeCommonBannerAdobe.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCourseReviewsTwitter from '~/components/Te/TeCourse/TeCourseReviewsTwitter.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeTeCourseFirstSidejobPriceTable3Columns from '~/components/Te/TeCourse/FirstSidejob/TeTeCourseFirstSidejobPriceTable3Columns.vue'
import TeCoursePriceGreatPlan from '~/components/Te/TeCourse/TeCoursePriceGreatPlan.vue'
import TeCoursePriceInstallments from '~/components/Te/TeCourse/TeCoursePriceInstallments.vue'
import TeCommonPricePreviously from '~/components/Te/TeCommon/Price/TeCommonPricePreviously/TeCommonPricePreviously.vue'
import TeCommonBannerCrowdloan from '~/components/Te/TeCommon/Banner/Crowdloan/TeCommonBannerCrowdloan.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCommonComparisonSchoolSidejob from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchoolSidejob/TeCommonComparisonSchoolSidejob.vue'
import TeCourseFirstSidejobFlow from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobFlow.vue'
import TeCourseFirstSidejobFaQ from '~/components/Te/TeCourse/FirstSidejob/TeCourseFirstSidejobFaQ.vue'
import TeCommonBannerPcBeginner from '~/components/Te/TeCommon/Banner/TeCommonBannerPcBeginner/TeCommonBannerPcBeginner.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faHouseLaptop } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faAngleRight, faCheck } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = 'first-sidejob-oneonone-plan' // はじめての副業コース
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faHouseLaptop,
      faAngleRight,
      faCheck,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true, // Facebookピクセル
      criteoScript: true, // Criteo
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title:
        '未経験からのプログラミング副業コース/受講者数No.1 | テックアカデミー',
      meta: [
        ...metaTags({
          description:
            '【テックアカデミー(TechAcademy)】最短4週間でプログラミング未経験からWeb制作の副業ができるスキルの習得を目指すコース。現役エンジニアのパーソナルメンターが週に2回のマンツーマンメンタリング、毎日のチャットでサポート。',
          twitterTitle: 'はじめての副業コース',
          twitterDescription:
            '最短4週間でプログラミング未経験から副業ができるスキルの習得を目指すコース。',
          twitterImage: '/_nuxt/ogp/te/tecourse/og-image-first-sidejob.jpg',
          ogTitle: 'はじめての副業コース',
          ogDescription:
            '最短4週間でプログラミング未経験から副業ができるスキルの習得を目指すコース。',
          ogUrl: '/course/first-sidejob',
          ogImage: '/_nuxt/ogp/te/tecourse/og-image-first-sidejob.jpg',
        }),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseFirstSidejobCover,
    TeCommonPagenav,
    TeCourseFirstSidejobBannerLinks,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerThousand,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseFirstSidejobMerit,
    TeCommonTechAcademyWorks,
    TeCommonGraduateFirstSidejobNew,
    TeCommonSliderWorkExample,
    TeCommonSidejobTimeSchedule,
    TeCommonBannerFreeTrial,
    TeCourseFirstSidejobCurriculumNew,
    TeCommonBannerAdobe,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCourseReviewsTwitter,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeTeCourseFirstSidejobPriceTable3Columns,
    TeCoursePriceGreatPlan,
    TeCoursePriceInstallments,
    TeCommonPricePreviously,
    TeCommonBannerCrowdloan,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCommonComparisonSchoolSidejob,
    TeCourseFirstSidejobFlow,
    TeCourseFirstSidejobFaQ,
    TeCommonBannerPcBeginner,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
